// extracted by mini-css-extract-plugin
export default {"title":"_l4JR7tMIt70q9tk56o1","mobile":"VfTy2f_PZ4744jHeiNs3","subtitle":"VpfRZqV_DRNR1gsd8aom"};